
/* CONFIGURATION */
export const GET_CONFIGURATION_LISTING = "GET_CONFIGURATION_LISTING";
export const GET_CONFIGURATION_LISTING_SUCCESS = "GET_CONFIGURATION_LISTING_SUCCESS";
export const GET_CONFIGURATION_LISTING_FAIL = "GET_CONFIGURATION_LISTING_FAIL";

export const GET_CONFIGURATION_DETAILS = "GET_CONFIGURATION_DETAILS";
export const GET_CONFIGURATION_DETAILS_SUCCESS = "GET_CONFIGURATION_DETAILS_SUCCESS";
export const GET_CONFIGURATION_DETAILS_FAIL = "GET_CONFIGURATION_DETAILS_FAIL";

export const ADD_CONFIGURATION = "ADD_CONFIGURATION";
export const ADD_CONFIGURATION_SUCCESS = "ADD_CONFIGURATION_SUCCESS";
export const ADD_CONFIGURATION_FAIL = "ADD_CONFIGURATION_FAIL";

export const UPDATE_CONFIGURATION = "UPDATE_CONFIGURATION";
export const UPDATE_CONFIGURATION_SUCCESS = "UPDATE_CONFIGURATION_SUCCESS";
export const UPDATE_CONFIGURATION_FAIL = "UPDATE_CONFIGURATION_FAIL";

export const ADD_CONFIGURATION_ITEM = "ADD_CONFIGURATION_ITEM";
export const ADD_CONFIGURATION_ITEM_SUCCESS = "ADD_CONFIGURATION_ITEM_SUCCESS";
export const ADD_CONFIGURATION_ITEM_FAIL = "ADD_CONFIGURATION_ITEM_FAIL";

export const UPDATE_CONFIGURATION_ITEM = "UPDATE_CONFIGURATION_ITEM";
export const UPDATE_CONFIGURATION_ITEM_SUCCESS = "UPDATE_CONFIGURATION_ITEM_SUCCESS";
export const UPDATE_CONFIGURATION_ITEM_FAIL = "UPDATE_CONFIGURATION_ITEM_FAIL";

export const DELETE_CONFIGURATION = "DELETE_CONFIGURATION";
export const DELETE_CONFIGURATION_SUCCESS = "DELETE_CONFIGURATION_SUCCESS";
export const DELETE_CONFIGURATION_FAIL = "DELETE_CONFIGURATION_FAIL";

export const BULK_DELETE_CONFIGURATION = "BULK_DELETE_CONFIGURATION";
export const BULK_DELETE_CONFIGURATION_SUCCESS = "BULK_DELETE_CONFIGURATION_SUCCESS";
export const BULK_DELETE_CONFIGURATION_FAIL = "BULK_DELETE_CONFIGURATION_FAIL";

export const DELETE_CONFIGURATION_ITEM = "DELETE_CONFIGURATION_ITEM";
export const DELETE_CONFIGURATION_ITEM_SUCCESS = "DELETE_CONFIGURATION_ITEM_SUCCESS";
export const DELETE_CONFIGURATION_ITEM_FAIL = "DELETE_CONFIGURATION_ITEM_FAIL";

export const BULK_DELETE_CONFIGURATION_ITEM = "BULK_DELETE_CONFIGURATION_ITEM";
export const BULK_DELETE_CONFIGURATION_ITEM_SUCCESS = "BULK_DELETE_CONFIGURATION_ITEM_SUCCESS";
export const BULK_DELETE_CONFIGURATION_ITEM_FAIL = "BULK_DELETE_CONFIGURATION_ITEM_FAIL";

export const EXPORT_CONFIGURATION = "EXPORT_CONFIGURATION";
export const EXPORT_CONFIGURATION_SUCCESS = "EXPORT_CONFIGURATION_SUCCESS";
export const EXPORT_CONFIGURATION_FAIL = "EXPORT_CONFIGURATION_FAIL";

export const RESET_CONFIGURATION_STATE = 'RESET_CONFIGURATION_STATE';